import React from "react";
import { motion } from "framer-motion";
import {
  ArrowRight,
  BadgeCheck,
  ChartColumnBig,
  ChartNoAxesCombined,
  Goal,
  Handshake,
  NotepadText,
  TrainFrontTunnel,
} from "lucide-react";
import { BackgroundBeams } from "../../../ui/background-beams";
import { Spotlight } from "../../../ui/spotlight-new";
import {
  scrollVariantsLeft,
  scrollVariantsRight,
} from "../../../../constants/TextAnimation";
import { Grid } from "../../../ui/Grid";
import { Link, useNavigate } from "react-router-dom";

const RealEstate = () => {
  const points = [
    {
      title: "Market Expertise",
      description:
        "In-depth knowledge of high-growth real estate markets across different markets",
    },
    {
      title: "Personalized Strategies",
      description:
        "Advisory services tailored to your investment goals and risk appetite",
    },
    {
      title: "Data–Driven Insights",
      description:
        "Real-time analytics and forecasts to inform smarter decisions",
    },
    {
      title: "Professional Network",
      description:
        "Strong partnerships with developers, brokers, and Centres of Influence to secure the best deals",
    },
    {
      title: "Sustainable Investments",
      description: "Focus on long-term value creation and sustainability",
    },
  ];

  const navigate = useNavigate();
  return (
    <>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className=""
      >
        <section
          className="relative"
          // style={{ backgroundImage: "url('/images/ourExpertise/1.jpg')" }}
        >
          <Spotlight />
          {/* <div className="absolute inset-0 bg-black/80 z-0" />
          <div className="container mx-auto px-4 z-10">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white !leading-tight mb-6">
                Unlocking Opportunities in Real Estate
              </h1>

              <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed">
                With expertise in dynamic markets, we provide strategic insights
                and personalized advisory to help you make impactful real estate
                investments
              </p>

              <div className="flex flex-col md:flex-row justify-center gap-4">
                <button className="px-6 py-3 bg-gold hover:bg-opacity-75 text-black font-medium rounded-lg transition-colors duration-300 flex items-center justify-center">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button className="px-6 py-3 bg-transparent border border-white text-white hover:bg-white hover:text-blue-900 font-medium rounded-lg transition-colors duration-300">
                  Learn More
                </button>
              </div>
            </div>
          </div> */}

          <div className="h-[32rem] md:h-[43rem] w-full rounded-md bg-neutral-950 relative flex flex-col items-center justify-center antialiased">
            <div className="max-w-3xl mx-auto p-4">
              <h1 className="relative z-10 text-3xl md:text-6xl mb-6 mt-10 bg-clip-text text-transparent bg-gradient-to-b from-neutral-200 to-neutral-600  text-center font-sans font-bold">
                Unlocking Opportunities in Real Estate
              </h1>
              <p className="text-neutral-200 max-w-lg mx-auto my-2 text-base text-center relative z-10">
                With expertise in dynamic markets, we provide strategic insights
                and personalized advisory to help you make impactful real estate
                investments
              </p>
              <div className="flex flex-row justify-center gap-4 pt-10 relative z-10">
                {/* <button
                  className="px-6 py-3 bg-gold hover:bg-opacity-75 text-black font-medium rounded-lg transition-colors duration-300 flex items-center justify-center"
                  onClick={() => navigate("/contact")}
                >
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button
                  className="px-6 py-3 bg-white border border-white text-slate-900 hover:bg-white hover:text-blue-900 font-medium rounded-lg transition-colors duration-300"
                  onClick={() => navigate("/contact")}
                >
                  Learn More
                </button> */}
                <div className="inline-block">
                  <Link
                    to="/contact"
                    className="flex justify-center gap-2 items-center mx-auto shadow-xl text-base bg-gradient text-slate-900 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-gold hover:text-slate-900 hover:border-gold before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 ps-4 pe-1 py-1 overflow-hidden border-2 rounded-full group"
                  >
                    Get Started
                    <svg
                      className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 ease-linear duration-300  bg-black text-white p-2 rounded-full group-hover:border-none rotate-45"
                      viewBox="0 0 16 19"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                        className="fill-white group-hover:fill-gray-800"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
            <BackgroundBeams />
          </div>
        </section>

        {/* cta */}
        <section className="bg-blac 2xl:py-24 2xl:bg-gray-50 relative bg-gradient-to-tr from-gold/10 via-transparent">
          <div className="px-4 mx-auto bg-blac max-w-7xl sm:px-6 lg:px-8 2xl:rounded-xl">
            <div className="py-10 sm:py-16 lg:py-24 2xl:pl-24">
              <div className="grid items-center grid-cols-1 gap-y-8 lg:grid-cols-2 lg:gap-x-8 2xl:gap-x-20">
                <motion.div
                  initial="visible"
                  whileInView="visible"
                  variants={scrollVariantsLeft}
                  viewport={{ amount: 0.3 }}
                  className="lg:order-2 2xl:-mr-24"
                >
                  <img
                    className="w-full shadow-xl rounded-xl"
                    src="/images/ourExpertise/2.png"
                    alt=""
                  />
                </motion.div>

                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  variants={scrollVariantsRight}
                  viewport={{ amount: 0.3 }}
                  className="lg:order-1"
                >
                  <h2
                    className="text-2xl font-bold leading-tight text-whit sm:text-3xl lg:text-4xl lg:leading-tight"
                    style={{ fontFamily: "monospace" }}
                  >
                    Your Partner in Real Estate {""}
                    <br className="hidden xl:block" />
                    Success
                  </h2>
                  <p className="mt-3 text-base md:text-lg text-gray-400">
                    At Scan Global Holdings, we specialize in unlocking
                    high-value real estate opportunities in thriving markets.
                    Whether you're exploring residential, commercial, or
                    mixed-use properties, our tailored strategies ensure you
                    maximize value and minimize risk.
                  </p>

                  <ul className="grid grid-cols-1 mt-4 sm:mt-10 sm:grid-cols-2 gap-x-10 xl:gap-x-16 gap-y-4 xl:gap-y-6">
                    <li className="flex items-start">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gold"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="ml-3 leading-5">
                        {" "}
                        <strong className="font-medium">
                          {" "}
                          10+ years of experience in managing real estate
                        </strong>{" "}
                      </span>
                    </li>

                    <li className="flex items-start">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gold"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="ml-3 leading-5 font-normal text-whit">
                        {" "}
                        Presence in{" "}
                        <strong className="font-medium">
                          High-Growth Markets
                        </strong>{" "}
                      </span>
                    </li>

                    <li className="flex items-start">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-gold"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="ml-3 leading-5 font-normal">
                        {" "}
                        <strong className="font-medium">
                          25% Average ROI
                        </strong>{" "}
                        achieved for clients on strategic investments{" "}
                      </span>
                    </li>
                  </ul>

                  <div className="flex flex-col items-start mt-8 md:space-x-4 md:flex-row md:items-center lg:mt-6 gap-5">
                    <a
                      href="/contact"
                      title=""
                      className="inline-flex text-nowrap items-center justify-center px-4 py-2 text-base font-semibold text-black transition-all duration-100 bg-gold border border-transparent hover:bg-opacity-85 focus:bg-opacity-85 w-[200px]"
                      role="button"
                    >
                      <span className="p-1 bg-black text-white me-3">
                        <Handshake />
                      </span>
                      Get In Touch
                    </a>

                    <a
                      // href="/contact"
                      onClick={(e) => {
                        e.preventDefault();
                        document
                          .getElementById("core")
                          .scrollIntoView({ behavior: "smooth" });
                      }}
                      title=""
                      className="inline-flex text-nowrap items-center justify-center px-4 py-3 text-base font-semibold text-gold transition-all duration-200 bg-transparent border border-gold sm:mt-0 hover:bg-gold hover:text-slate-900 w-[200px]"
                      role="button"
                    >
                      {" "}
                      Explore Our Expertise{" "}
                    </a>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        <section className="container py-16 grid md:grid-cols-2 gap-10 items-center">
          {/* Left Image */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={scrollVariantsRight}
            viewport={{ amount: 0.3 }}
          >
            <img
              src="/images/ourExpertise/3.jpg"
              alt="Skyline"
              className="rounded-xl w-full"
            />
          </motion.div>

          {/* Right Content */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={scrollVariantsLeft}
            viewport={{ amount: 0.3 }}
          >
            <h2 className="text-2xl md:text-4xl font-bold mb-4 leading-tight">
              Why Businesses and Investors Choose Scan?
            </h2>
            <p className="text-gray-300 mb-6 text-base leading-relaxed">
              Our real estate advisory services are built on deep market
              knowledge, strategic foresight, and a commitment to delivering
              measurable success. Here’s what makes us unique:
            </p>

            <div className="space-y-4">
              {points.map((point, idx) => (
                <div key={idx} className="flex items-start space-x-3">
                  <span className="text-gold text-xl mt-1">
                    <BadgeCheck />
                  </span>
                  <p className="text-gray-400 text-base leading-6">
                    <strong className="text-gold">{point.title}:</strong>{" "}
                    {point.description}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>
        </section>

        <section
          className="py-10 sm:py-16 lg:pt-36 lg:pb-24 container"
          id="core"
        >
          <motion.h6
            initial="hidden"
            whileInView="visible"
            variants={scrollVariantsRight}
            viewport={{ amount: 0.3 }}
            className="font-semibold text-white pb-8"
          >
            <span className="relative inline-block text-white text-lg md:text-2xl uppercase tracking-wide">
              Core Services
              {/* Gradient underline like ::before */}
              <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
            </span>
          </motion.h6>

          <div className="flex gap-6 flex-col">
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={scrollVariantsLeft}
              viewport={{ amount: 0.3 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 sm:grid-cols-2 gap-6"
            >
              <div className="p-4 bg-slate-800/40 rounded-tr-2xl rounded-bl-2xl relative overflow-hidden">
                <Grid size={20} />
                <Goal size={50} className="text-gold" />
                <div className="text-xl font-semibold mt-2">
                  Investment Strategy Development
                </div>
                <p className="text-gray-200 mt-2 leading-tight">
                  Crafting tailored strategies to align with your investment
                  objectives and market conditions
                </p>
              </div>

              <div className="p-4 bg-slate-800/40 rounded-tr-2xl rounded-bl-2xl relative overflow-hidden">
                <Grid size={20} />
                <ChartNoAxesCombined size={50} className="text-gold" />
                <div className="text-xl font-semibold mt-2">
                  Market Analysis & Insights
                </div>
                <p className="text-gray-200 mt-2 leading-tight">
                  Providing in-depth market research and analytics to identify
                  high-potential opportunities
                </p>
              </div>
            </motion.div>

            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={scrollVariantsRight}
              viewport={{ amount: 0.3 }}
              className="flex gap-6"
            >
              <div className="p-4 bg-slate-800/40 rounded-tr-2xl rounded-bl-2xl relative overflow-hidden">
                <Grid size={20} />
                <ChartColumnBig size={50} className="text-gold" />
                <div className="text-xl font-semibold mt-2">
                  Property Valuation
                </div>
                <p className="text-gray-200 mt-2 leading-tight">
                  Accurate assessments to ensure investments align with true
                  market value
                </p>
              </div>
              <div className="p-4 bg-slate-800/40 rounded-tr-2xl rounded-bl-2xl relative overflow-hidden">
                <Grid size={20} />
                <NotepadText size={50} className="text-gold" />
                <div className="text-xl font-semibold mt-2">
                  Transaction Management
                </div>
                <p className="text-gray-200 mt-2 leading-tight">
                  Managing negotiations, contracts, and compliance for seamless
                  property acquisitions
                </p>
              </div>
            </motion.div>
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={scrollVariantsLeft}
              viewport={{ amount: 0.3 }}
              className="grid gap-6 gris-cols-6 md:grid-cols-12"
            >
              <div className="col-span-5"></div>

              <div className="p-4 bg-slate-800/40 rounded-tr-2xl rounded-bl-2xl col-span-5 relative overflow-hidden">
                <Grid size={20} />
                <TrainFrontTunnel size={50} className="text-gold" />
                <div className="text-xl font-semibold mt-2">
                  Portfolio Diversification
                </div>
                <p className="text-gray-200 mt-2 leading-tight">
                  Helping clients build resilient portfolios across residential,
                  commercial, and mixed-use properties
                </p>
              </div>
            </motion.div>
          </div>
        </section>
      </motion.div>
    </>
  );
};

export default RealEstate;
